import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {
  Button,
  Divider,
  IconButton,
  MenuItem,
  Typography,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Title} from 'components/forms';
import CustomAlert from 'components/grid-dx/alert';
import {useGetToken} from 'components/hooks';
import {i18n2} from 'features/i18n/i18n';
import {FastField, Field, FieldArray, Form, Formik} from 'formik';
import {Checkbox, TextField} from 'formik-material-ui';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {getChoiceById} from '../hooks/index';
import {ChoiceSchema} from '../model/Choice';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '1%',
    marginBottom: '2%',
  },
  title: {
    marginBottom: '2%',
    textAlign: 'center',
  },
  radioButton: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  deletedButton: {
    // color: "rgba(255,0,0,0.8)"
    color: '#bb2124',
  },
  checkedButton: {
    color: '#56D500',
  },
}));

const CreateChoicePopup = ({
  open,
  handleClose,
  remoteAdd,
  remoteChange,
  edit,
  ids,
  noEdit,
  refresh,
}) => {
  const classes = useStyles();
  const token = useGetToken();
  const user = useSelector((state) => state.authentication.user.name);
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    successful: false,
  });
  const [data, setData] = React.useState({
    iD_Course: ids.idCourse,
    iD_Content: ids.idContent,
    type: 0,
    question: '',
    answers: [
      {
        text_Answer: '',
        correctAnswer: false,
      },
    ],
    user: user,
    reason: '',
    pass: '',
  });

  useEffect(() => {
    if (edit != null) {
      getChoiceById(
        edit ? edit.iD_Choice : null,
        ids.idCourse,
        ids.idContent,
        token,
      )
        .then((data) => {
          if (typeof data !== 'undefined') {
            if (data.answers) {
              setData({
                ...data,
                user: user,
                reason: '',
                pass: '',
              });
            } else {
              setData({
                iD_Course: ids.idCourse,
                iD_Content: ids.idContent,
                type: 0,
                question: '',
                answers: [
                  {
                    text_Answer: '',
                    correctAnswer: false,
                  },
                ],
                user: user,
                reason: '',
                pass: '',
              });
            }
          }
        })
        .catch(() => {});
    } else {
      setData({
        iD_Course: ids.idCourse,
        iD_Content: ids.idContent,
        type: 0,
        question: '',
        answers: [
          {
            text_Answer: '',
            correctAnswer: false,
          },
        ],
        user: user,
        reason: '',
        pass: '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const submit = async (values, formikBag) => {
    if (edit) {
      const editingOptions = {
        row: edit,
        changed: values,
      };
      try {
        const response = await remoteChange(editingOptions);
        if (response.ok) {
          setMessage({
            text: i18n2._('Editado correctamente'),
            open: true,
            successful: true,
          });
          setTimeout(() => {
            handleClose();
            refresh();
          }, 1000);
        } else {
          formikBag.setSubmitting(false);
          response
            .text()
            .then((message) =>
              setMessage({text: message, open: true, successful: false}),
            );
        }
      } catch (error) {
        return console.log(error);
      }
    } else {
      let addingOptions = {
        added: values,
      };
      try {
        const response = await remoteAdd(addingOptions);
        if (response.ok) {
          setMessage({
            text: i18n2._('Creado correctamente'),
            open: true,
            successful: true,
          });
          setTimeout(() => {
            handleClose();
            refresh();
          }, 1000);
        } else {
          formikBag.setSubmitting(false);
          response
            .text()
            .then((message) =>
              setMessage({text: message, open: true, successful: false}),
            );
        }
      } catch (error) {
        return console.log(error);
      }
    }
  };

  const onChangeType = (value, answers, setFieldValue) => {
    answers.map((answer, index) =>
      setFieldValue(`answers.${index}.correctAnswer`, false),
    );
    setFieldValue('type', value);
  };
  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
        fullWidth
        PaperProps={{
          style: {
            height: '95vh',
            maxHeight: '95vh',
            padding: '8px 16px',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
        onClose={handleClose}>
        <Title onClose={handleClose} title={i18n2._('Pregunta')} />
        <DialogContent
          style={{
            flex: 1,
            overflow: 'visible',
            paddingBottom: '8px',
          }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
              initialValues={data}
              enableReinitialize
              onSubmit={submit}
              validationSchema={ChoiceSchema()}>
              {(formikProps) => {
                if (noEdit) formikProps.isSubmitting = true;

                return (
                  <Form>
                    <Grid container spacing={3}>
                      {/* Columna izquierda */}
                      <Grid item md={6} xs={12}>
                        <Grid container spacing={2} style={{paddingTop: '6px'}}>
                          {/* Tipo */}
                          <Grid item xs={12}>
                            <Field
                              name="type"
                              component={TextField}
                              select
                              required
                              label={i18n2._('Tipo')}
                              fullWidth
                              variant="outlined"
                              InputProps={{
                                onChange: (e) =>
                                  onChangeType(
                                    e.target.value,
                                    formikProps.values.answers,
                                    formikProps.setFieldValue,
                                  ),
                              }}>
                              <MenuItem value={0}>
                                <Trans>Simple</Trans>
                              </MenuItem>
                              <MenuItem value={1}>
                                <Trans>Múltiple</Trans>
                              </MenuItem>
                            </Field>
                          </Grid>

                          {/* Pregunta */}
                          <Grid item xs={12}>
                            <Field
                              name="question"
                              required
                              component={TextField}
                              label={i18n2._('Pregunta')}
                              fullWidth
                              variant="outlined"
                              multiline
                              rows={3}
                            />
                          </Grid>
                          {!noEdit && (
                            <Grid item xs={12}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                  }}>
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    gutterBottom
                                    style={{
                                      marginBottom: '4px',
                                    }}>
                                    <Trans>
                                      Marque con un ✔️ las respuestas correctas
                                    </Trans>
                                  </Typography>
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      formikProps.setFieldValue('answers', [
                                        ...formikProps.values.answers,
                                        {text_Answer: '', correctAnswer: false},
                                      ])
                                    }
                                    style={{
                                      color: '#1c4257',
                                      borderColor: '#1c4257',
                                      backgroundColor:
                                        'rgba(21, 101, 192, 0.1)',
                                      '&:hover': {
                                        backgroundColor:
                                          'rgba(21, 101, 192, 0.25)',
                                        borderColor: '#0D47A1',
                                      },
                                    }}>
                                    {i18n2._('Agregar respuesta')}
                                  </Button>
                                </div>
                              </div>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      {/* Columna derecha */}
                      <Grid item md={6} xs={12}>
                        <div
                          style={{
                            height: '48vh',
                            overflowY: 'auto',
                            paddingRight: '8px',
                            paddingTop: '6px',
                          }}>
                          <FieldArray
                            name="answers"
                            render={(arrayHelpers) => (
                              <div>
                                {formikProps.values.answers.map(
                                  (answer, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        marginBottom: '16px',
                                      }}>
                                      {/* Radio o Checkbox */}
                                      {formikProps.values.type === 0 ? (
                                        <IconButton
                                          aria-label="checkbox"
                                          onClick={() => {
                                            if (!noEdit) {
                                              formikProps.values.answers.forEach(
                                                (a, i) =>
                                                  formikProps.setFieldValue(
                                                    `answers.${i}.correctAnswer`,
                                                    i === index,
                                                  ),
                                              );
                                            }
                                          }}>
                                          {answer.correctAnswer === false ? (
                                            <CircleUnchecked
                                              className={
                                                !noEdit
                                                  ? classes.radioButton
                                                  : null
                                              }
                                            />
                                          ) : (
                                            <CircleCheckedFilled
                                              className={
                                                !noEdit
                                                  ? classes.checkedButton
                                                  : null
                                              }
                                            />
                                          )}
                                        </IconButton>
                                      ) : (
                                        <Field
                                          component={Checkbox}
                                          name={`answers.${index}.correctAnswer`}
                                        />
                                      )}

                                      {/* Respuesta */}
                                      <Field
                                        name={`answers.${index}.text_Answer`}
                                        component={TextField}
                                        label={i18n2._('Respuesta')}
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        minRows={1}
                                        maxRows={5}
                                        style={{
                                          marginRight: 8,
                                        }}
                                      />

                                      {/* Eliminar */}
                                      {formikProps.values.answers.length > 1 &&
                                        !noEdit && (
                                          <IconButton
                                            aria-label="delete"
                                            className={classes.deletedButton}
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }>
                                            <DeleteIcon />
                                          </IconButton>
                                        )}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                          />
                        </div>
                      </Grid>

                      {/* Motivo y credenciales */}
                      {!noEdit && (
                        <>
                          <Divider style={{width: '100%'}} />
                          <Grid item xs={12}>
                            <Field
                              label={i18n2._('Motivo')}
                              name={'reason'}
                              fullWidth
                              variant="outlined"
                              component={TextField}
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Field
                              label={i18n2._('Usuario')}
                              name={'user'}
                              variant="standard"
                              size="small"
                              fullWidth
                              component={TextField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <FastField
                              label={i18n2._('Contraseña')}
                              name={'pass'}
                              variant="standard"
                              size="small"
                              fullWidth
                              component={TextField}
                              type="password"
                              validate={(value) => {
                                let error;
                                if (value && value.length === 0) {
                                  error = i18n2._(
                                    'Por favor ingrese una contraseña',
                                  );
                                }
                                return error;
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </>
                      )}

                      {/* Botones finales */}
                      {!noEdit && (
                        <Grid item xs={12}>
                          <div style={{float: 'right', marginTop: '8px'}}>
                            <Button
                              onClick={() => handleClose()}
                              className="red-text">
                              {i18n2._('Cancelar')}
                            </Button>
                            <Button
                              type="submit"
                              disabled={formikProps.isSubmitting}
                              variant="contained"
                              color="primary">
                              {edit ? (
                                <Trans>Editar</Trans>
                              ) : (
                                <Trans>Crear</Trans>
                              )}
                            </Button>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </MuiPickersUtilsProvider>
        </DialogContent>
        <CustomAlert
          message={message.text}
          ms={1000}
          successful={message.successful}
          handleClose={() => setMessage((prev) => ({...prev, open: false}))}
          open={message.open}
        />
      </Dialog>
    </>
  );
};

export default CreateChoicePopup;
